import React from "react";
import { Grid, Switch } from "@mui/material";
import FormField from "layouts/pages/account/components/FormField";
import SoftTypography from "components/SoftTypography";
import SoftBox from "components/SoftBox";
import SoftButton from "components/SoftButton";
import SettingsCard from "./SettingsCard";
import banner from "assets/images/banner.png";

const HeroContentSection = ({ 
  inputData, 
  showMap, 
  handleToggleChange,
  main_image,
  previewMainImage,
  handleImageUpload
}) => {
  return (
    <SettingsCard
      title="Hero Section"
      subtitle="Configure hero section content and styling"
      gridProps={{
        xs: 12,
        sx: {
          "@media (min-width: 1100px)": {
            flexBasis: "calc(50% - 12px)",
            maxWidth: "calc(50% - 12px)",
            width: "calc(50% - 12px)",
            marginRight: "24px"
          }
        }
      }}
    >
      <Grid container spacing={2.5}>
        {!showMap && (
          <>
            <Grid item xs={12}>
              <SoftBox 
                display="flex" 
                flexDirection="column"
                alignItems="flex-start" 
                mb={0}
                sx={{
                  width: "100%",
                  maxWidth: "600px"
                }}
              >
                <SoftBox
                  sx={{
                    width: "100%",
                    maxWidth: "600px",
                    height: "120px",
                    border: "1.5px solid #e0e0e0",
                    borderRadius: "12px",
                    padding: "12px",
                    backgroundColor: "#f9f9f9",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    overflow: "hidden",
                    cursor: "pointer",
                    position: "relative",
                    mb: 0.25
                  }}
                  onClick={() => document.getElementById("main_image_input").click()}
                >
                  <input type="hidden" name="main_image" value={main_image} />
                  {previewMainImage || banner ? (
                    <>
                      <img
                        src={previewMainImage || banner}
                        alt="main_image"
                        style={{ 
                          maxWidth: "100%", 
                          maxHeight: "100%", 
                          width: "auto", 
                          height: "auto",
                          objectFit: "contain",
                          borderRadius: "8px"
                        }}
                      />
                      <input
                        id="main_image_input"
                        hidden
                        accept="image/*"
                        type="file"
                        onChange={(e) => {
                          handleImageUpload(e, "main_image");
                          // Reset input value so same file can be selected again
                          e.target.value = "";
                        }}
                      />
                    </>
                  ) : (
                    <SoftButton variant="outlined" component="label" color="dark">
                      Upload Main Image
                      <input
                        hidden
                        accept="image/*"
                        type="file"
                        onChange={(e) => handleImageUpload(e, "main_image")}
                      />
                    </SoftButton>
                  )}
                </SoftBox>
                <SoftTypography
                  variant="caption"
                  sx={{
                    fontSize: "11px",
                    color: "#666",
                    marginTop: "6px"
                  }}
                >
                  Recommended: (1280px x 320px) 4:1 ratio. 1MB size.
                </SoftTypography>
              </SoftBox>
            </Grid>
          </>
        )}
        
        <Grid item xs={12}>
          <SoftBox display="flex" alignItems="center" mb={1}>
            <Switch checked={showMap} onChange={handleToggleChange} />
            <SoftTypography 
              variant="body2" 
              sx={{ marginLeft: "10px", fontSize: "14px" }}
            >
              Display Map
            </SoftTypography>
          </SoftBox>
        </Grid>
        
        <Grid item xs={12} md={6}>
          <FormField
            defaultValue={inputData?.title || "Find Local Businesses You Can Trust"}
            label="Title"
            name="title"
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <FormField
            defaultValue={
              inputData?.sub_title ||
              "Search by name, category, or keyword — and support the businesses that make your community thrive."
            }
            label="Sub Title"
            name="sub_title"
          />
        </Grid>
        <Grid item xs={12}>
          <SoftTypography 
            variant="caption" 
            color="text" 
            mb={1.5}
            sx={{ opacity: 0.7, fontSize: "0.75rem", display: "block" }}
          >
            Text Colors
          </SoftTypography>
        </Grid>
        <Grid item xs={12} md={6}>
          <FormField
            defaultValue={inputData?.hero_text_heading || "#ffffff"}
            className="color-input"
            label="Heading Text Color"
            name="hero_text_heading"
            inputProps={{ type: "color" }}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <FormField
            defaultValue={inputData?.hero_text_sub_heading || "#ffffff"}
            className="color-input"
            label="Sub Heading Text Color"
            name="hero_text_sub_heading"
            inputProps={{ type: "color" }}
          />
        </Grid>
      </Grid>
    </SettingsCard>
  );
};

export default HeroContentSection;
